import React from 'react'
import { Button } from 'react-bootstrap'
import './styles.scss'

interface ToggleButtonProps {
  showText?: string
  hideText?: string
  isOpen?: boolean
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

const ToggleButton = ({
  showText = 'Show Details',
  hideText = 'Hide Details',
  isOpen = false,
  onClick
}: ToggleButtonProps): JSX.Element => {
  return (
    <div className='ui-toggle-button'>
      <Button variant='link' onClick={onClick}>
        {isOpen ? hideText : showText}
        <span className={`mdi mdi-${isOpen ? 'menu-up' : 'menu-down'}`} />
      </Button>
    </div>
  )
}

export default ToggleButton
